import UnifiedNavbar from './UnifiedNavbar';

interface LayoutWrapperProps {
  children: React.ReactNode;
}

const LayoutWrapper = ({ children }: LayoutWrapperProps) => {
  return (
    <>
      <UnifiedNavbar />
      {children}
    </>
  );
};

export default LayoutWrapper;
